import React from "react";
import { useTranslation } from "react-i18next";

const CheckrDeniedPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="workflow-container centered">
      <div className="red-flag-message">
        {t("selfSignIn.denied.unableToComplete")}
        <br />
        {t("selfSignIn.denied.seeAttendant")}
      </div>
    </div>
  );
};

export default CheckrDeniedPage;
